module.exports = __webpack_public_path__ + "static/img/profile-target-4.73b8f706.png";